import { css } from 'styled-jsx/css';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { colors } from '../Theme';
import { useRouter } from 'next/router';

const iconSizeXS = '32px';
const iconSizeS = '64px';
const iconSizeL = '100px';
const styles = css`
  .tips-container {
    margin: 12px 0 36px 0;
    padding: 0px 12px 0px;
  }

  .tips-container--colored {
    background-color: #e0e5e9;
  }

  .tips {
    display: flex;
    margin: 0 auto;
    padding: 0;
    max-width: 1150px;
    flex-wrap: wrap;
    justify-content: space-between;
    list-style: none;
    gap: 20px;
  }

  .tips-centered {
    justify-content: center;
  }

  .tips-side{
    flex-direction: row;
    justify-content: space-evenly;
  }

  .tip-item {
    position: relative;
    padding-top: 76px;
    margin-top: 12px;
    text-align: center;
  }
  .tip-item-active:hover{
    cursor: pointer;
  }
  .tip-item::before {
    position: absolute;
    margin-left: -32px;
    left: 50%;
    content: "";
    width: ${iconSizeS};
    height ${iconSizeS};
    top: 0;
    background-repeat: no-repeat;
  }

  .icon--assistance::before {
    background-image: url('/static/images/icons/assistance.svg');
  }

  .icon--luggages::before {
    background-image: url('/static/images/icons/luggages.svg');
  }

  .icon--hopital::before {
    background-image: url('/static/images/icons/hopital.svg');
  }

  .icon--people::before {
    background-image: url('/static/images/icons/people.svg');
  }

  .icon--three-fingers::before {
    background-image: url('/static/images/icons/three-fingers.svg');
  }

  .icon--planet::before {
    background-image: url('/static/images/icons/planet.svg');
  }

  .icon--hey::before {
    background-image: url('/static/images/icons/hey.svg');
  }

  .tip-emphasis {
    color: ${colors.ywgNavy};
    font-weight: 700;
  }
  .tip-item-active:hover>.tip-emphasis{
    text-decoration: underline;
    color: ${colors.ywgPrimary};
  }
  @media(max-width: 1149px) {

    .tip-item-side {
      display: flex;
      padding-top: 0;
      max-width: 40%;
      align-items: center;
      flex-direction: column;
    }

    .tip-item-active.tip-item-side{
      text-decoration: underline;
    }
    .tip-item-side::before {
      position: initial;

      width: ${iconSizeXS};
      height: ${iconSizeXS};
      line-height: ${iconSizeXS};
      margin-left: 0;
      left: 0;
    }
  }

  @media(min-width: 1150px) {
    .tip-emphasis{
      font-size: 1.2rem;
    }
    .tips-container{
      margin: 72px 0 72px 0;
      padding: 0 12px;
    }
    .tip-item {
      margin-top: 0;
      padding-top: 130px;
      flex-shrink: 0;
      flex-basis: 240px;
    }
    .tip-item::before{
      margin-left: -50px;
      width: ${iconSizeL};
      height ${iconSizeL};
    }
  }
`;

const Tips = ({ side, items, colored, centered }) => {
  const router = useRouter();
  const smoothScroll = anchor => e => {
    e.preventDefault();
    router.push(`${router.asPath}#${anchor}`);
    //const top = document.querySelector(`#${anchor}`).offsetTop;
    //scrollTo({ top });
  };
  return (
    <>
      <div
        className={classnames('tips-container', {
          'tips-container--colored': colored
        })}
      >
        <ul
          className={classnames('tips', {
            'tips-centered': centered,
            'tips-side': side
          })}
        >
          {items.map((item, i) => (
            <li
              className={classnames('tip-item', item.class, item.icon, {
                'tip-item-side': side,
                'tip-item-active': item.href
              })}
              key={i}
              onClick={item.href ? smoothScroll(item.href) : null}
            >
              {item.text ? (
                <span className="tip-emphasis">{item.text}</span>
              ) : null}
              {item.texts ? (
                <>
                  {item.texts.em
                    ? item.texts.em.map((text, j) => (
                        <div className="tip-emphasis" key={`tip-${j}`}>
                          {text}
                        </div>
                      ))
                    : null}

                  {item.texts.p
                    ? item.texts.p.map((text, j) => (
                        <div key={`tip-${j}`}>{text}</div>
                      ))
                    : null}
                </>
              ) : null}
            </li>
          ))}
        </ul>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

Tips.propTypes = {
  side: PropTypes.bool,
  items: PropTypes.array,
  colored: PropTypes.bool,
  centered: PropTypes.bool
};

export default Tips;
